import mitt from 'mitt';
import { Message } from '@/lib/models/message';

export type Events = {
  message: Message;
};

export default mitt<Events>();
